import VideoPlayerV3 from "@/components/ui/VideoPlayerV3";
import { VideoData } from "@/redux/feature/videoDashboard/videoDashboardType";

const BrandVideosCard = ({
  video,
  currentlyPlaying,
  setCurrentlyPlaying,
}: {
  setCurrentlyPlaying: React.Dispatch<React.SetStateAction<string | null>>;
  currentlyPlaying: string | null;
  video: VideoData;
}) => {
  return (
    <div className="h-full">
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-md transition-shadow duration-200 h-full">
        {/* Video Player Section */}
        <div className="h-40 relative bg-gray-200">
          <VideoPlayerV3
            thumbnailUrl={video.thumbnail_url}
            url={video.video_url}
            currentlyPlaying={currentlyPlaying}
            setCurrentlyPlaying={setCurrentlyPlaying}
            className="rounded-none w-full h-full object-cover"
          />

          {/* Ad/Organic Badge */}
          <div className="absolute z-50 top-3 right-3">
            <span
              className={`px-2 py-1 text-xs font-medium rounded-full ${
                video.ad_or_organic === "Ad"
                  ? "bg-blue-100 text-blue-700"
                  : "bg-green-100 text-green-700"
              }`}
            >
              {video.ad_or_organic}
            </span>
          </div>
          <div className="p-4 space-y-3 flex-1 flex flex-col">
            <div className="flex items-center gap-3 flex-shrink-0">
              {video.page_profile_picture_url ? (
                <img
                  src={video.page_profile_picture_url}
                  alt={`${video.brand} logo`}
                  className="w-8 h-8 rounded-full object-cover flex-shrink-0"
                />
              ) : (
                <div className="w-8 h-8 rounded-full bg-gray-300 flex-shrink-0" />
              )}
              <div className="flex-1 min-w-0">
                <h3 className="font-medium text-gray-900 text-sm truncate">
                  {video.brand}
                </h3>
                <p className="text-xs text-gray-500 truncate">
                  {video?.published_on}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrandVideosCard;

export const BrandVideoCardSkeleton = () => (
  <div className="h-full">
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-md transition-shadow duration-200 h-full">
      {/* Video Player Skeleton */}
      <div className="h-40 relative bg-gray-200 animate-pulse">
        {/* Ad/Organic Badge Skeleton */}
        <div className="absolute z-50 top-3 right-3">
          <div className="w-12 h-6 bg-gray-300 rounded-full animate-pulse"></div>
        </div>

        {/* Content Section Skeleton */}
        <div className="p-4 space-y-3 flex-1 flex flex-col">
          {/* Brand Header Skeleton */}
          <div className="flex items-center gap-3 flex-shrink-0">
            {/* Profile Picture Skeleton */}
            <div className="w-8 h-8 rounded-full bg-gray-300 animate-pulse flex-shrink-0"></div>

            {/* Brand Info Skeleton */}
            <div className="flex-1 min-w-0">
              <div className="w-20 h-4 bg-gray-300 rounded animate-pulse mb-1"></div>
              <div className="w-16 h-3 bg-gray-200 rounded animate-pulse"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);
